import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const ZipCodeField = () => {
  return (
    <FormField label="Zip Code" htmlFor="zipCode">
      <FormikInput id="zipCode" name="address.zipCode" />
    </FormField>
  );
};

export default ZipCodeField;
